

  function addShipping(){
    if(!document.querySelector('.footer-row.custom') && document.querySelector('.rewards-pre-unlock-text')){
      if (jQuery('.footer.sticky-footer > .footer-row:last').prev()[0].className != 'footer-row custom') {
        jQuery('.footer-row.custom').remove();
        jQuery('.footer.sticky-footer .footer-row:last').before(`<div class="footer-row custom" style="display:none;"><span class="flex" >Shipping Charges</span><span style="font-weight: 600;">$3.95</span></div>`)
      }
     } else if (!document.querySelector('.rewards-pre-unlock-text')){
      jQuery('.footer-row.custom').remove();
    }
  }

  function cartShowOffer(){
    if (document.querySelector('#slidecarthq .price-discount-block')) {
      let offerText;
      if (document.querySelector('.card__badge .nowrap')) {
        offerText = jQuery('.card__badge .nowrap:first').text().trim();
      } else if(document.querySelector('.price__badge-sale .nowrap')){
        offerText = document.querySelector('.price__badge-sale .nowrap').textContent.split('-')[0];
      }
  
      if (offerText) {
        jQuery('#slidecarthq .item').each(function (index, el) {
          if (jQuery(el).find('.saleText').length == 0) {
            jQuery(el).find('.price-discount-block').append(`<span class="saleText" style="display:none; background: #dd1d1d; border-radius: 4px; color: white; font-family: 'Inter'; font-size: 11px; padding: 1px 4px; line-height: 150%; font-weight: 600; letter-spacing: 1px; position: absolute; bottom: 112%; width: max-content; right: 0;"> ${offerText} </span>`)
          }
        })
      }
    }
  }

function addGiftBox() {
  jQuery(document).ready(() => {
    jQuery(".item").each(function (index, el) {
      if (jQuery(el).find(".giftWrapWrapper").length == 0) {
        
        jQuery(el).find(".item-container").after(`
          <div class="giftWrapWrapper" style="margin-top: 12px;">
  <div
    class="giftWrap"
    style="background-color: #f7f7f7; border-radius: 12px; padding: 8px"
  >
    <label
      class="giftWrapHeading"
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
      "
    >
      Add Gift Wrapping for $3.95
      <input
        style="display: none"
        type="checkbox"
        name="giftWrapCheck"
        id="giftWrapCheck"
        style="appearance: auto"
      />
      <span></span>
    </label>

    <div class="giftWrapOptions" style="display: none">
      <div style="margin: 8px 0; font-size: 14px; color: #5b5b5be5 !important;">Select the pattern of gift wrapping:</div>

      <form>
        <label
          class="giftWrapSingle"
          style="
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;
          "
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <input
              type="radio"
              name="giftWrapRadio"
              id="silver"
              style="appearance: auto"
              checked
            />
            <img src="https://cdn.shopify.com/s/files/1/0626/3154/3121/files/2_c55876b8-bfd1-4572-bd06-1b418c7df9aa.png?v=1729531225" alt="" width="48" height="48" />
            Silver
          </div>
          <div>$3.95</div>
        </label>

        <label
          class="giftWrapSingle"
          style="
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <input
              name="giftWrapRadio"
              type="radio"
              id="christmas"
              style="appearance: auto"
            />
            <img src="https://cdn.shopify.com/s/files/1/0626/3154/3121/files/1_1714bcdb-7e57-4f9a-a06f-783722f93f72.png?v=1729531250" alt="" width="48" height="48" />
            Christmas
          </div>
          <div>$3.95</div>
        </label>
      </form>

      <button
        class="applyGift"
        style="
          margin-left: auto;
          display: block;
          width: 125px;
          text-align: center;
          background: #f04f36;
          color: white;
          padding: 8px 0;
          border-radius: 4px;
        "
      >
        Apply
      </button>
    </div>
  </div>
</div>
        `);
        if (jQuery(el).find('wrapped-extension wrapped-feature-checkbox-simple input:checked').length != 0) {
          jQuery('.item').find('#giftWrapCheck').prop('checked', true);
        }
      } else{
        if (jQuery(el).find('wrapped-extension wrapped-feature-checkbox-simple input:checked').length != 0) {
          jQuery(el).find('#giftWrapCheck').prop('checked', true);
        } else{
          jQuery(el).find('#giftWrapCheck').prop('checked', false);
        }
      }
    });
  });
}

const cartEventRefresh = new Event("cartRefresh");
document.addEventListener("cartRefresh", (e) => {
  console.log("refreshed");
  addGiftBox();
  SLIDECART_UPDATE();
    cartShowOffer();
  addShipping();
});


document.addEventListener("click", function (e) {
  if (e.target.className == "applyGift") {
    if (!jQuery(e.target).parents(".item").find("wrapped-feature-checkbox-simple input").prop('checked')) {
      jQuery(e.target)
      .parents(".item")
      .find("wrapped-feature-checkbox-simple input")
      .trigger("click");
    }
    let checkWrap = jQuery(e.target).parents(".item").find('input[name="giftWrapRadio"]:checked').attr('id');
    if (checkWrap == 'silver') {
      jQuery(e.target).parents(".item").find('input[value="49803245814097"]').click();
    } else if (checkWrap == 'christmas') {
      jQuery(e.target).parents(".item").find('input[value="49803242471761"]').click();
    }
    jQuery(e.target).parents(".item").find('.giftWrapOptions').css('display','none');
  } else if (e.target.id == "giftWrapCheck" && e.target.checked) {
    jQuery(e.target)
      .parents(".giftWrapWrapper")
      .find(".giftWrapOptions")
      .css("display", "block");
  } else if (e.target.id == "giftWrapCheck" && !e.target.checked) {
    jQuery(e.target)
      .parents(".giftWrapWrapper")
      .find(".giftWrapOptions")
      .css("display", "none");
    if (jQuery(e.target).parents(".item").find("wrapped-feature-checkbox-simple input").prop('checked')) {
      jQuery(e.target)
      .parents(".item")
      .find("wrapped-feature-checkbox-simple input")
      .trigger("click");
    }
  }
});

window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
  SLIDECART_UPDATE();
  addGiftBox();
    cartShowOffer();
  addShipping();
  // window.Wrapped.buildExtensions(!0);
}

window.SLIDECART_OPENED = function() {
  SLIDECART_UPDATE();
  addGiftBox();
    cartShowOffer();
  addShipping();
  // window.Wrapped.buildExtensions(!0);
}

window.SLIDECART_LOADED = function (cart) {
  console.log(cart, 'loaded');
  document.querySelector('.product-form__submit').disabled = false;
  // SLIDECART_UPDATE();
  cartShowOffer();
  addShipping();
  addGiftBox();
  window.Wrapped.buildExtensions(!0)
};

window.SLIDECART_UPDATED = function(cart) {
  console.log(cart);
  addGiftBox();
    cartShowOffer();
  addShipping();
  // window.Wrapped.buildExtensions(!0);
}


window.SLIDECART_UPDATED = async function(cart) {
  var newCart = cart
  var total = 0

  for(var i = 0; i < newCart.items.length; i++) {
    var item = newCart.items[i]  
    var res = await axios.get('/products/' + item.handle + '.js')
    var variant = res.data.variants.find(i => i.id == item.variant_id)
    var compare = variant.compare_at_price
    
    total += (compare - variant.price) * item.quantity
    newCart.items[i].original_line_price = compare * item.quantity

  }
  
  newCart.total_discount = total
  window.SLIDECART_SET_CART(newCart)
  window.Wrapped.buildExtensions(!0)
  addGiftBox();
  cartShowOffer();
  addShipping();
}
